import type {IconName} from '@vio/atlas/Icon'

export const RANKED_AMENITIES: {
  id: string
  icon: IconName
}[] = [
  {id: '49', icon: 'Bath'}, // Bath
  {id: '445', icon: 'Bath'}, // Private bathroom
  {id: '637', icon: 'Wifi'}, // Wi-Fi (Free)
  {id: '515', icon: 'Shower'}, // Shower
  {id: '22', icon: 'Ice'}, // Air Conditioning
  {id: '41', icon: 'Patio'}, // Balcony
  {id: '421', icon: 'Patio'}, // Patio
  {id: '278', icon: 'Temperature'}, // Heating
  {id: '632', icon: 'Disability'}, // Wheelchair Accessible
  {id: '601', icon: 'Monitor'}, // TV
  {id: '140', icon: 'Mug2'}, // Coffee/Tea Making Facilities
  {id: '269', icon: 'Hairdryer'}, // Hairdryer
  {id: '487', icon: 'Safe'}, // Safety Deposit Box
  {id: '485', icon: 'Safe'}, // Safe
  {id: '169', icon: 'Trampoline'}, // Desk
  {id: '576', icon: 'ToiletRoll'}, // Toilet
  {id: '621', icon: 'CoatHanger'}, // Wardrobe
  {id: '581', icon: 'SoapPump'}, // Toiletries
  {id: '311', icon: 'Iron'}, // Iron and ironing Board
  {id: '310', icon: 'Iron'}, // Iron
  {id: '634', icon: 'Wifi'} // Wi-Fi
]
